module.exports = __webpack_public_path__ + "static/media/bg-frame-grey.14a38bfb.png";